import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { VariableSetsListComponent } from './variable-sets-list.component';

@NgModule({
  declarations: [VariableSetsListComponent],
  exports: [VariableSetsListComponent],
  imports: [CommonModule, MatListModule, MatTooltipModule, MatCheckboxModule]
})
export class VariableSetsListModule { }
